import { render } from "./UserMessageAdd.vue?vue&type=template&id=4e4f89f4"
import script from "./UserMessageAdd.vue?vue&type=script&lang=js"
export * from "./UserMessageAdd.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__